import { render, staticRenderFns } from "./EditConnectionDialogMixin.vue?vue&type=template&id=28a5a7c4"
import script from "./EditConnectionDialogMixin.vue?vue&type=script&lang=ts"
export * from "./EditConnectionDialogMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports